import React from 'react';
import QRCode from '../QRGenerator.js';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

/*import { toast } from 'react-toastify';*/
import 'react-toastify/dist/ReactToastify.min.css';

import Logo from '../../../../views/assets/global/img/AssetVault_logo_80.jpg';

export default class ModalQRGenerator extends React.Component {
	constructor(){
		super()
		this.initialState = {
			isGenerating : true,
			QRvalue : null,
		}
		this.state 		= this.initialState;

	};

	renderQRField(){
		if(this.state.QRvalue !== null){
			return(
				<div className="form-group col-sm-12">
					
					<div className="text-center">
						<QRCode 
						    value = {
						        JSON.stringify({
						            type : this.props.QRtype,
						            value : this.state.QRvalue   
						        })
						    }
						    logo = {Logo} 
						    logoWidth = {50}
						    size = {160}
						    customSize = {'100%'}
						/>
						<span className="text-muted">{this.props.message}</span> 
					</div>
				</div>
				
			)
		}else{
			return(
				<div className="card-block align-center NoDataContainer">
				  <div>
				    <span><i className="fa fa-5x fa-qrcode"></i></span><br/>
				    <span><i className="fa fa-cog fa-spin fa-fw" />&nbsp;<i>Generating . . .</i></span><br/>
				  </div>
				</div>
			)
		}
	}

	willMount(){		
		// this.setState(this.initialState)
	};

	willUnMount(){
		this.setState(this.initialState)
	};

	componentWillReceiveProps(nextProps){
		if(nextProps.QRvalue !== null){
			this.setState({QRvalue : nextProps.QRvalue})
		}
	}

	render(){
		return(
			<Modal 
				isOpen		= {this.props.isOpen}
				onExit		= {() => this.willUnMount()}
				onEnter 	= {() => this.willMount()} 
				toggle 		= {this.props.closeModal} 
			>
				<ModalHeader toggle={this.props.closeModal}><i className="fa fa-qrcode"></i>&nbsp;{this.props.modalTitle}</ModalHeader>
				<ModalBody>						
					<div className="row">
						{this.renderQRField()}
					</div>
				</ModalBody>
				<ModalFooter>
					<Button color="danger" onClick={this.props.closeModal}>Close</Button>
				</ModalFooter>
			</Modal>
		)
	};
}


// WEBPACK FOOTER //
// ./src/App/qrreader/helper/component/Modal/ModalQRGenerator.js